export const FORM_TYPE = {
  BusinessPlus: "BUSINESS_PLUS",
  BusinessPrime: "BUSINESS_PRIME",
  IndividualPlus: "INDIVIDUAL_PLUS",
  IndividualPrime: "INDIVIDUAL_PRIME",
  Business: "BUSINESS",
};

export const FORM_TYPE_LABELS = {
  BUSINESS_PLUS: "Business Plus",
  BUSINESS_PRIME: "Business Prime",
  INDIVIDUAL_PLUS: "Individual Plus",
  INDIVIDUAL_PRIME: "Individual Prime",
  BUSINESS: "Business",
};

export const APPLICATION_STATUS_LABELS = {
  0: "In progress",
  1: "Submitted",
  2: "In progress",
  3: "Approved",
  4: "Not available",
  5: "Submitted",
  6: "Completed",
  7: "Not available",
  8: "Not available",
  9: "Closed",
};

export const getApplicationStatusLabel = (status) => {
  const normalizedStatus = typeof status === "string" ? status.trim() : status;
  if (normalizedStatus === null || normalizedStatus === undefined || normalizedStatus === "") {
    return "Status unavailable";
  }

  const statusKey = Number(normalizedStatus);
  if (!Number.isFinite(statusKey)) {
    return "Status unavailable";
  }

  return APPLICATION_STATUS_LABELS?.[statusKey] ?? "Status unavailable";
};

export const getBusinessFamilyLabel = (applicationType) => {
  switch (Number(applicationType)) {
    case 1:
      return "Business Plus";
    case 2:
      return "Business Prime";
    case 3:
      return "Business Prime Upgrade";
    default:
      return FORM_TYPE_LABELS.BUSINESS;
  }
};

export const getFormTypeLabel = (formType, applicationType = null) => (
  formType === FORM_TYPE.Business ||
  (formType === FORM_TYPE.BusinessPlus && Number(applicationType) === 2) ||
  (formType === FORM_TYPE.BusinessPrime && Number(applicationType) === 3)
    ? getBusinessFamilyLabel(applicationType)
    : FORM_TYPE_LABELS?.[formType] ?? formType
);

export const getApplicationTitle = (formType, applicationType = null) => {
  if (formType === FORM_TYPE.Business || formType === FORM_TYPE.BusinessPlus || formType === FORM_TYPE.BusinessPrime) {
    const businessLabel = formType === FORM_TYPE.Business
      ? getBusinessFamilyLabel(applicationType)
      : FORM_TYPE_LABELS?.[formType] ?? "Business";
    return `${businessLabel} Account Application`;
  }

  return getFormTypeLabel(formType, applicationType);
};
